import { getStore as getMailStore } from '../store/Store';
import { mutatorAction } from 'satcheljs';
import Item from 'owa-service/lib/contract/Item';

/**
 * Updates the suggested reply data in the item inside the store
 */
export const updateSuggestedReplies = mutatorAction(
    'updateSuggestedReplies',
    (itemId: string, responseItem: Item) => {
        const existingItem = getMailStore().items.get(itemId);
        existingItem.ExtendedProperty = [
            ...existingItem.ExtendedProperty,
            ...responseItem.ExtendedProperty,
        ];
    }
);
